import ajaxRequest, { fetchWrapper } from '@/utils/request';

const state = {
    profilePromise: null,

    profile: {
        first_name: '',
        last_name: '',
        sex: null,
        phone: null,
        email: null,
        legal_entity: null,
        legal_address: null,
        legal_inn: null,
        legal_kpp: null,
        max_shops: null
    },

    experiments: new Set()
};

const getters = {
};

const actions = {
    getProfile(context) {
        context.state.profilePromise = new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/users/get_info/',
                success({data}) {
                    context.commit('setProfile', {resolve, profile: data});

                    resolve();
                }
            });
        });
        return context.state.profilePromise;
    },
    saveProfile(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/users/save/',
                method: 'POST',
                params,
                success({data}) {
                    context.commit('setProfile', {resolve, profile: data});
                },
                failure({errors}) {
                    reject({errors});
                }
            });
        });
    },

    async getExperiments(context) {
        return fetchWrapper('/experiments/get/')
            .then(({ data }) => {
                context.commit('setExperiments', data);
            });
    }
};

const mutations = {
    setProfile(state, { resolve, profile }) {
        state.profile = profile;

        resolve && resolve();
    },

    setExperiments(state, experiments) {
        state.experiments = new Set(experiments);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js